import Marquee from "react-fast-marquee";

const ITEMS = [
  "HEAVY HIGHWAY CONSTRUCTION",
  "ASPHALT PAVING & RESURFACING",
  "FULL-DEPTH RECLAMATION",
  "FOB ASPHALT SALES",
  "SITE PREPARATION",
  "FDOT TRUSTED PARTNER",
];

export default function MarqueeBar() {
  return (
    <div data-testid="marquee-bar" className="bg-rc-charcoal py-5 border-y border-white/5">
      <Marquee speed={45} gradient={false}>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-mono text-rc-sand text-sm uppercase tracking-[0.25em] px-8">{t}</span>
            <span className="text-rc-red text-lg">●</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
